import { type UseQueryResult, useQuery } from 'react-query';
import {
  GrantService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_GrantListDto,
} from '../../services/wealthlane-award-services';
import { type TableParamsType } from '../../types/common';

const useGetGrantList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
  // planId?: any,
  // grantTypeId?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_GrantListDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount, planId, grantTypeId, _force } = tableInfo;
  const grantList = useQuery(
    ['getGrantList', planId, grantTypeId, filter, sorting, skipCount, maxResultCount, _force],
    async () => {
      return await handleRequest(
        GrantService.getApiAwardApiAppGrantGrantList(
          planId,
          grantTypeId,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return grantList;
};

export default useGetGrantList;
